import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './lib/auth';
import { LanguageRoot } from './i18n';
import { ToastProvider } from './components/Toast';
import { queryClient } from './lib/queryClient';
import { router } from './router';
import './styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <LanguageRoot>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </LanguageRoot>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
